import { render, staticRenderFns } from "./DataPlanPopup.vue?vue&type=template&id=90844940&scoped=true&"
import script from "./DataPlanPopup.vue?vue&type=script&lang=js&"
export * from "./DataPlanPopup.vue?vue&type=script&lang=js&"
import style0 from "./DataPlanPopup.vue?vue&type=style&index=0&id=90844940&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90844940",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDialog,VIcon,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90844940')) {
      api.createRecord('90844940', component.options)
    } else {
      api.reload('90844940', component.options)
    }
    module.hot.accept("./DataPlanPopup.vue?vue&type=template&id=90844940&scoped=true&", function () {
      api.rerender('90844940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/plans/DataPlanPopup.vue"
export default component.exports